module.exports = __webpack_public_path__ + "img/white-vinegar.47c2018e.jpg";